import { defineListener, resourceTag, type ModuleListener } from '@krp/client-runtime'

import { AQSI_TAGS } from '../../../shared/api/tags'
import { exchangeApi } from '../api/exchangeApi'
import { saleExchangesReloadRequested } from './commands'

/** Команда «Обновить» окна обмена → перечитывание своего тега. Состояние модуля не нужно: запрос только читает. */
export function createExchangeListeners<S>(): ModuleListener<S>[] {
  return [
    defineListener<S, ReturnType<typeof saleExchangesReloadRequested>>(saleExchangesReloadRequested.match, (action, api) => {
      const { resourceId, saleId } = action.payload
      api.dispatch(exchangeApi.util.invalidateTags([resourceTag(AQSI_TAGS.saleExchanges, resourceId, saleId)]))
    }),
  ]
}
